<template>
	<span class="privacy-field-value d-inline-flex align-center">
		<template v-if="hasValue">
			<span
				class="privacy-field-value__text"
				:class="{ 'privacy-field-value__text--blurred': !revealed }"
			>{{ value }}</span>
			<v-btn
				icon
				x-small
				class="privacy-field-value__toggle ml-1"
				:aria-label="toggleAriaLabel"
				:title="toggleAriaLabel"
				@click="revealed = !revealed"
			>
				<v-icon small>{{ revealed ? 'mdi-eye-off' : 'mdi-eye' }}</v-icon>
			</v-btn>
		</template>
		<span v-else class="privacy-field-value__empty">—</span>
	</span>
</template>

<script>
import i18n from '@/lang/i18n';

export default {
	name: 'PrivacyFieldValue',

	props: {
		value: {
			type: [String, Number],
			default: '',
		},
	},

	data() {
		return {
			i18n,
			revealed: false,
		};
	},

	computed: {
		hasValue() {
			return this.value !== null && this.value !== undefined && String(this.value).trim() !== '';
		},

		toggleAriaLabel() {
			return this.revealed
				? i18n.t('modules.customdata.entity.privacy_hide')
				: i18n.t('modules.customdata.entity.privacy_show');
		},
	},

	watch: {
		value() {
			this.revealed = false;
		},
	},
};
</script>

<style lang="scss" scoped>
.privacy-field-value {
	&__text--blurred {
		filter: blur(4px);
		user-select: none;
	}

	&__toggle {
		flex-shrink: 0;
		opacity: 0.6;
		transition: opacity 0.2s ease;

		&:hover {
			opacity: 1;
		}
	}
}
</style>
